import { branding } from "./branding";

/**
 * The names a customer types when wiring the SDK up, derived once from the
 * branding config so no snippet, dialog or guide spells them itself.
 *
 * The environment variables are this deployment's own: every snippet passes
 * their values to the SDK explicitly, so the SDK's vendor-named variables are
 * never needed. The package and CLI names are the published ones, the one
 * deliberate exception documented in `branding.sdkPackageName`.
 */
export const ENV_API_KEY = `${branding.envPrefix}_API_KEY`;
export const ENV_PROJECT_ID = `${branding.envPrefix}_PROJECT_ID`;
export const ENV_ENDPOINT = `${branding.envPrefix}_ENDPOINT`;

/** Install line and import specifier of the observability SDK (npm and PyPI). */
export const SDK_PACKAGE = branding.sdkPackageName;
/**
 * The installed CLI's command. Install it, or run it through `npx`, with
 * `SDK_PACKAGE`: `npx` resolves a package name, not a binary.
 */
export const CLI_COMMAND = branding.cliCommand;

/**
 * What snippets call the SDK once it is imported. The import line has to
 * name the published package and class; everything after it reads under the
 * product's own name, so the vendor's name appears once, where it must.
 */
export const SDK_ALIAS = branding.attributeNamespace;
/** The SDK's client class as snippets bind it (`new VoxTest({...})`). */
export const SDK_CLASS_ALIAS = branding.productName.replace(
  /[^A-Za-z0-9_]/g,
  "",
);
/** `import langwatch as voxtest` */
export const PYTHON_SDK_IMPORT = `import ${SDK_PACKAGE} as ${SDK_ALIAS}`;
/** `import { LangWatch as VoxTest } from "langwatch";` */
export const TS_SDK_IMPORT = `import { LangWatch as ${SDK_CLASS_ALIAS} } from "${SDK_PACKAGE}";`;
